import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css"; // Import your CSS file

const Sidebar = () => {
  const location = useLocation();
  const [isMappingOpen, setIsMappingOpen] = useState(false);
  const [isVehicleDropdownOpen, setIsVehicleDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [vehicleNumbers] = useState([
    "KA01AB1234",
    "KA02CD5678",
    "KA03EF9101",
    "KA04GH1121",
    "KA05IJ3141",
    "KA06KL5161",
    "KA07MN7181",
    "KA08OP9202",
    "KA09QR1222",
    "KA10ST3242",
  ]);

  // Function to check if a link is active
  const isActive = (path) => (location.pathname === path ? "active-link" : "");

  // Effect to handle dropdown open/close logic on route change
  useEffect(() => {
    if (["/EMS", "/ICL", "/API", "/REST"].includes(location.pathname)) {
      setIsMappingOpen(true); // Keep the dropdown open if one of these is active
    } else {
      setIsMappingOpen(false); // Close the dropdown when clicking another page
    }

    // Close the Vehicle Numbers dropdown when the route changes
    setIsVehicleDropdownOpen(false);
  }, [location.pathname]); // Runs when the URL changes

  const toggleMappingMenu = () => {
    setIsMappingOpen(!isMappingOpen);
  };

  const toggleVehicleDropdown = () => {
    setIsVehicleDropdownOpen(!isVehicleDropdownOpen);
  };

  // Filter vehicle numbers based on search query
  const filteredVehicleNumbers = vehicleNumbers.filter((vehicle) =>
    vehicle.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="vertical-menu">
      <div data-simplebar className="h-100">
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {/* Map Link */}
            <li>
              <Link to="/map" className={isActive("/map")}>
                <i className="bx bx-map" />
                <span>Map</span>
              </Link>
            </li>

            {/* ProductList Link */}
            <li>
              <Link to="/ProductList" className={isActive("/ProductList")}>
                <i className="bx bx-cart" />
                <span>ProductList</span>
              </Link>
            </li>

            {/* Dashboard Link */}
            <li>
              <Link to="/dashboard" className={isActive("/dashboard")}>
                <i className="bx bx-grid-alt" />
                <span>Dashboard</span>
              </Link>
            </li>

            {/* Vehicle Number Dropdown */}
            <li className={isVehicleDropdownOpen ? "mm-active" : ""}>
              <a
                href="#!"
                className="has-arrow"
                aria-expanded={isVehicleDropdownOpen ? "true" : "false"}
                onClick={toggleVehicleDropdown}
              >
                <i className="bx bx-car" />
                <span>Vehicle List</span>
              </a>
              <ul className={`sub-menu mm-collapse ${isVehicleDropdownOpen ? "mm-show" : ""}`}>
                <li>
                  <div className="vehicle-search">
                    <input
                      type="text"
                      placeholder="Search vehicle number..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                  <div className="vehicle-list">
                    {filteredVehicleNumbers.map((vehicle, index) => (
                      <div key={index} className="vehicle-item text-white">
                        {vehicle}
                      </div>
                    ))}
                  </div>
                </li>
              </ul>
            </li>

            {/* Operational Data Dropdown */}
            <li className={isMappingOpen ? "mm-active" : ""}>
              <a
                href="#!"
                className="has-arrow"
                aria-expanded={isMappingOpen ? "true" : "false"}
                onClick={toggleMappingMenu}
              >
                <i className="bx bx-data" />
                <span>Operational Data</span>
              </a>
              <ul className={`sub-menu mm-collapse ${isMappingOpen ? "mm-show" : ""}`}>
                <li><Link to="/EMS" className={isActive("/EMS")}>EMS</Link></li>
                <li><Link to="/ICL" className={isActive("/ICL")}>ICL</Link></li>
              </ul>
            </li>

            {/* Other Links */}
            <li>
              <Link to="/trips" className={isActive("/trips")}>
                <i className="bx bx-file" />
                <span>Trips</span>
              </Link>
            </li>
            <li>
              <Link to="/fault-codes" className={isActive("/fault-codes")}>
                <i className="bx bx-error-circle" />
                <span>Fault Codes</span>
              </Link>
            </li>
            <li>
              <Link to="/charging" className={isActive("/charging")}>
                <i className="bx bx-battery" />
                <span>Charging</span>
              </Link>
            </li>
            <li>
              <Link to="/geofence" className={isActive("/geofence")}>
                <i className="bx bx-map" />
                <span>Geofence</span>
              </Link>
            </li>
            <li>
              <Link to="/parking" className={isActive("/parking")}>
                <i className="bx bx-car" />
                <span>Parking</span>
              </Link>
            </li>
            <li>
              <Link to="/violation" className={isActive("/violation")}>
                <i className="bx bx-shield" />
                <span>Violation</span>
              </Link>
            </li>
            <li>
              <Link to="/vhmd-trace" className={isActive("/vhmd-trace")}>
                <i className="bx bx-search" />
                <span>VHMD Trace</span>
              </Link>
            </li>
            <li>
              <Link to="/eco-driving" className={isActive("/eco-driving")}>
                <i className="bx bx-leaf" />
                <span>Eco Driving</span>
              </Link>
            </li>
            <li>
              <Link to="/refbox-temperature" className={isActive("/refbox-temperature")}>
                <i className="bx bxs-hot" />
                <span>RefBox Temperature</span>
              </Link>
            </li>
            <li>
              <Link to="/analysis" className={isActive("/analysis")}>
                <i className="bx bx-line-chart" />
                <span>Analysis</span>
              </Link>
            </li>
            <li>
              <Link to="/workshop" className={isActive("/workshop")}>
                <i className="bx bx-wrench" />
                <span>Workshop</span>
              </Link>
            </li>
            <li>
              <Link to="/transfer-files" className={isActive("/transfer-files")}>
                <i className="bx bx-upload" />
                <span>Transfer Files</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;